var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 21,
    viewBox: "0 0 13 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3446 10.9553L2.9947 20.4333C2.67449 20.7535 2.16217 20.7535 1.906 20.4333L0.625193 19.1525C0.30499 18.8323 0.30499 18.384 0.625193 18.0638L8.18199 10.3789L0.625193 2.75809C0.30499 2.43789 0.30499 1.92556 0.625193 1.6694L1.906 0.38859C2.16217 0.0683867 2.67449 0.0683867 2.9947 0.38859L12.3446 9.8666C12.6648 10.1868 12.6648 10.6351 12.3446 10.9553Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.ba551c22ac4af1fd8c855cd1ce421dcc.svg";
export { ForwardRef as ReactComponent };